const breakpoints = {
  xs: 480,
  sm: 768,
  md: 1074,
  lg: 1400,
  xl: 1920
};

export interface ScreenSize {
  width: number;
  height: number;
  isWidthXs: boolean;
  isWidthSm: boolean;
  isWidthMd: boolean;
  isWidthLg: boolean;
  isWidthXl: boolean;
  isPortrait: boolean;
  isLandscape: boolean;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

const getSizes = (height: number, width: number) => {
  const isWidthXs = width < breakpoints.sm;
  const isWidthSm = width >= breakpoints.sm && width < breakpoints.md;
  const isWidthMd = width >= breakpoints.md && width < breakpoints.lg;
  const isWidthLg = width >= breakpoints.lg && width < breakpoints.xl;
  const isWidthXl = width >= breakpoints.xl;
  const isPortrait = window.screen.height > window.screen.width;
  const isLandscape = window.screen.height < window.screen.width;

  return {
    width,
    height,
    isWidthXs,
    isWidthSm,
    isWidthMd,
    isWidthLg,
    isWidthXl,
    isPortrait,
    isLandscape,
    isMobile: isWidthXs,
    isTablet: isWidthSm,
    isDesktop: isWidthMd || isWidthLg || isWidthXl
  };
};

export default getSizes;
